import React from 'react'
import './cardItemCategory.scss';
import { Link } from 'react-router-dom';
import { textConvertUrl } from '../../../../core/hooks/textConvert';

export default function CardItemCategory({ data }: any) {
    return (
        <div className='category_element'>
            <h1 className='title'>Categorías</h1>
            <div className='items'>
                {data.map((item: any, index: number) => (
                    <div key={index} className='item'>
                        <Link to={`/c/${textConvertUrl(item.title)}`}>
                            <p className='element'><i className="fa-solid fa-hand-point-right"></i> {item.title}</p>
                        </Link>
                    </div>
                ))}
            </div>
        </div>
    )
}


